export default "__VITE_ASSET__COXI37yM__"